import { useState } from 'react';
import { useRequest } from 'ahooks';
import { getKnowlegeByOutsideUser } from '../../../service/theme';
import { knowledgesStore, userStore } from '../../../store';
import { Toast } from 'antd-mobile';
import useUrlSearch from '../../../utils/useUrlSearch';

export default function useService() {

    const { page, pageSize } = userStore;
    const { getByKey } = useUrlSearch();
    const [knowledgeList, setknowledgeList] = useState([]);

    const { loading, run: runKnowledge } = useRequest(() => getKnowlegeByOutsideUser({
        page,
        pageSize,
        themeId: getByKey('themeId')
    }), {
        manual: true,
        onSuccess: (result, params) => {
            if (result.status) {
                // knowledgesStore.knowledges = result.data.rows;
                setknowledgeList(result.data.rows)
            }
        },
        onError: (error) => {
            Toast.show({
                content: '请求课程出错了',
            })
        },
    });

    return { loading, runKnowledge, knowledgeList }
}
